import { useFormContext as h, Controller as C } from "../../node_modules/react-hook-form/dist/index.esm.js";
import "../../UI/style.js";
import "../../node_modules/classnames/index.js";
import "../../UI/FormGrid/formGrid2.js";
import { jsx as r } from "../../_virtual/jsx-runtime.js";
import { UIInputContainer as x } from "../../UI/FormGrid/InputContainer.js";
import "../../UI/Input/UIInputText.js";
import "../../UI/Input/UIInputDate.js";
import { UIInputCheckbox as I } from "../../UI/Input/UIInputCheckbox.js";
import "../../UI/Input/UIInputFile.js";
import "../../UI/Input/UIInputTextArea.js";
import "../../UI/Blocks/Button/Button.js";
import "../../UI/Blocks/Emphasis/emphasis2.js";
import "../../UI/Blocks/Card/card2.js";
import "react";
import "../../UI/Blocks/Toaster/toast2.js";
import "../../UI/Blocks/Toaster/toaster2.js";
function D({
  name: p,
  onChange: m,
  label: e,
  disabled: i,
  className: a,
  size: n,
  required: u
}) {
  const {
    control: c
  } = h();
  return /* @__PURE__ */ r(C, {
    name: p,
    control: c,
    render: ({
      field: o,
      fieldState: {
        error: t
      }
    }) => /* @__PURE__ */ r(x, {
      size: n,
      name: o.name,
      errorMessage: t == null ? void 0 : t.message,
      children: /* @__PURE__ */ r(I, {
        hasError: !!t,
        disabled: i,
        className: a,
        size: n,
        ref: o.ref,
        name: o.name,
        value: o.value,
        onBlur: o.onBlur,
        onChange: m ? (s) => m(s.target.checked) : o.onChange,
        label: e,
        required: u
      })
    })
  });
}
export {
  D as InputCheckbox
};
//# sourceMappingURL=InputCheckbox.js.map
